import React from 'react'
import { Helmet } from 'react-helmet'

const SeoStructuredData = ({ data }) => {

    return (
        <Helmet>
            
            {data &&
                <script type="application/ld+json">{`${data}`}</script>
            }

        </Helmet>
    )
}

export default SeoStructuredData